import { colors, Text } from "@vericus/cadmus-ui";

import missingRubric from "@/assets/illustrations/student-with-lens-on-paper.png";

export function EmptyRubric() {
  return (
    <div
      style={{
        backgroundColor: colors.lilac200,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={missingRubric} alt="No submissions" style={{ width: 332 }} />
      <Text kind="headingFour" style={{ marginTop: 36 }}>
        There isn&apos;t a rubric available for this task yet.
      </Text>
    </div>
  );
}
